import i18n from '@/plugins/i18n'
import { FOOTER_COMPONENT_NAMES, footerHelpers } from '../../components/public/footers/index'
import Home from '../../components/views/opensalud/Home'
import auth from '../../app/auth';
import LogoutSuccess from '../../components/views/opensalud/LogoutSuccess';
import UserInfoStore from '../../app/user-info-store';
import UserInfoApi from '../../app/user-info-api';
import { PUBLIC_LAYOUT, PUBLIC_REDUCED_LAYOUT, PUBLIC_MENU_LAYOUT, PUBLIC_EXTENDED_LAYOUT, OPENSALUD_EMPRESAS_LAYOUT, OPENSALUD_PROFESIONALES_LAYOUT } from '@/constants/layouts'
import { OPENSALUD_PLATFORM_NAME, OPENSALUD360_PLATFORM_NAME, OPENSALUD_PROFESIONALES_PLATFORM_NAME } from '@/constants/platformNames'
import { OPENLEGAL360_LOGO, OPENSALUD360_LOGO } from '@/constants/logosFileNames'
import { OPENLEGAL_THEME, getThemeName } from '@/constants/themes'
import errorRoutes from './error.routes'
import { API_CLIENT_ROLE } from '@/constants/roles'
import Vue from 'vue'

function requireAuth(to, from, next) {
  if (!auth.auth.isUserSignedIn()) {
      UserInfoStore.setLoggedIn(false);
      next({
      path: '/login',
      query: { redirect: to.fullPath }
      });
  } else {
    UserInfoApi.getUserInfo().then(response => {
      UserInfoStore.setLoggedIn(true);
      UserInfoStore.setCognitoInfo(response);
      next();
    });
  }
}
const layout = PUBLIC_LAYOUT
const footer = {
  component: FOOTER_COMPONENT_NAMES.OPENLEGAL

}
const themeOpenlegal = 'openlegal-theme'
const i18nFile = 'public/views/openlegal'
const tagLine = 'Openlegal'
function scrollTop(to, from, next) {
  window.scrollTo(0, 0)
  next()
}

export default [
  {
    path: 'support-chat',
    name: 'SupportChat',
    component: () => import('@/components/public/HubspotChat'),
    meta: {
      footer: {
        disabled: true
      }
    }
  },
  // Account views
  {
    path: 'signup-cognito',
    name: 'SignUpCognito',
    component: () => import('@/components/public/account/SignUpCognito'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('sign-up')
        }
      }
    }
  },
  {
    path: 'signup',
    name: 'SignUpCertificate',
    component: () => import('@/components/public/account/SignUpCertificate'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('sign-up')
        }
      }
    }
  },
/*   {
    path: 'login-cognito',
    name: 'LoginCognito',
    component: () => import('@/components/public/account/LoginCognito'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text: i18n.t('log-in')
      }
    }
  }, */
  {
    path: 'inicio-sesion',
    name: 'InicioSesion',
    component: () => import('@/components/views/account/LoginOrRegister'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text () {
          return i18n.t('log-in')
        },
        hide: true
      },
      i18n: 'public/views/account/login.json',
      showInstallAppButton: true
    }
  },
  {
    path: 'account/login',
    redirect: { name: 'InicioSesion' }
  },
  {
    path: 'homepaciente',
    beforeEnter (to, from, next) {
      window.location.href = helpers.getAppUrl('HomePaciente')
    }
  },
  {
    path: 'homeprofesional',
    beforeEnter (to, from, next) {
      window.location.href = helpers.getAppUrl('HomeProfesional')
    }
  },
  {
    path: 'homecentro',
    beforeEnter (to, from, next) {
      window.location.href = helpers.getAppUrl('HomeCentro')
    }
  },
  {
    path: 'home/index',
    redirect: '/'
  },
  /* {
    path: 'cuenta/reactivar',
    name: 'ReenableAccount',
    component: () => import('@/components/public/account/ReenableAccount'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text: i18n.t('reenable-account')
      }
    }
  }, */
/*   {
    path: 'new-password',
    name: 'NewPassword',
    component: () => import('@/components/public/account/NewPassword'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text: i18n.t('change-password')
      }
    }
  },
  {
    path: 'recover-password',
    name: 'RecoverPassword',
    component: () => import('@/components/public/account/RecoverPassword'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text: i18n.t('recover-password.title')
      }
    }
  }, */
  {
    path: 'payments-gateway',
    name: 'PaymentsGateway',
    component: () => import('@/components/public/payments/PaymentsGateway'),
    meta: {
      layout: PUBLIC_EXTENDED_LAYOUT,
      footer: {
        disabled: true
      },
      title: {
        text () {
          return i18n.t('payments-gateway.title')
        }
      }
    }
  },
  {
    name: 'comunidad-saludable',
    path: 'comunidad-saludable',
    component: () => import('@/components/views/healthy-community/HealthyCommunity'),
    meta: {
      // layout: PUBLIC_MENU_LAYOUT,
      title: {
        text () {
          return i18n.t('healthyCommunityTitle')
        }
      },
      i18n: 'public/views/healthy-community'
    }
  },
  {
    path: 'opensalud360/empresas',
    name: 'Empresas',
		beforeEnter () {
			window.location.replace('https://prime.opensalud.es/empresas')
		}
    /* component: () => import('@/components/views/opensalud/EmpresasNew'),
    meta: {
      layout: OPENSALUD_EMPRESAS_LAYOUT,
      title: {
        text () {
          return  i18n.t('business-title')
        }
      },
      tagLine: OPENSALUD360_PLATFORM_NAME,
      i18n: 'public/views/opensalud-empresas-new.json',
      gtag: OPENSALUD360_PLATFORM_NAME
    } */
  },
  {
    path: 'opensalud360/empresas/gracias',
    name: 'ContactFormSuccessOpensalud360',
    component: () => import('@/components/views/CompaniesContactFormSuccess'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      i18n: 'forms/companies-contact-form.json',
      gtag: OPENSALUD360_PLATFORM_NAME,
      title: {
        text () {
          return i18n.t('companies-contact-form.form.thank-you')
        }
      }
    }
  },
  {
    path: 'opensalud360/contacto',
    name: 'Contacto360',
    component: () => import('@/components/views/opensalud/ContactoEmpresas'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      footer: {
        component: footerHelpers.getFooterComponentName()
      },
      title: {
        text () {
          return i18n.t('contact-title')
        },
        hide: true
      },
      tagLine: OPENSALUD360_PLATFORM_NAME,
     
    }
  },
  {
    path: 'contacto',
    name: 'Contacto',
    component: () => import('@/components/views/opensalud/Contacto'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      footer: {
        component: footerHelpers.getFooterComponentName()
      },
      title: {
        text () {
          return i18n.t('contact-title')
        },
        hide: true
      },
      tagLine: OPENSALUD_PLATFORM_NAME,
     
    }
  },
  {
    path: 'opensalud4all-contacto',
    name: 'ContactoOpensalud4All',
    component: () => import('@/components/forms/Opensalud4allContactForm'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      footer: {
        component: footerHelpers.getFooterComponentName()
      },
      title: {
        text () {
          return i18n.t('contact-title')
        },
        hide: true
      },
      tagLine: OPENSALUD_PLATFORM_NAME,
     
    }
  },
  {
    path: 'openlegal360/empresas',
    name: 'Openlegal360',
    component: () => import('@/components/views/openlegal/Vertical'),
    meta: {
      tagLine,
      title: {
        text () {
          return i18n.t('openlegal.title')
        }
      },
      layout,
      footer,
      footer: {
        component: FOOTER_COMPONENT_NAMES.OPENLEGAL360
      },
      logo: {
        src: OPENLEGAL360_LOGO
      },
      theme: themeOpenlegal,
      i18n: i18nFile
    }
  },
  {
    path: 'profesionales',
    name: 'Profesionales',
    component: () => import('@/components/views/opensalud/Profesionales'),
    meta: {
      layout: OPENSALUD_PROFESIONALES_LAYOUT,
      title: {
        text () {
          return i18n.t('main-professional-block-h1')
        }
      },
      tagLine: OPENSALUD_PROFESIONALES_PLATFORM_NAME,
      i18n: 'public/views/opensalud-profesionales.json'
    }
  },
  {
    path: 'tarifas-profesionales',
    name: 'Tarifas profesionales',
    component: () => import('@/components/views/opensalud/TarifasProfesionales'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text () {
          return i18n.t('patient-title')
        }
      },
      tagLine: OPENSALUD_PROFESIONALES_PLATFORM_NAME,
      i18n: 'public/views/opensalud-profesionales.json'
    }
  },
  {
    path: 'sign-up',
    name: 'Signup',
    component: () => import('@/components/views/SignUp'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text () {
          return i18n.t('sign-up')
        }
      },
      footer: {
        component: FOOTER_COMPONENT_NAMES.OPENSALUD360
      },
      tagLine: OPENSALUD360_PLATFORM_NAME,
      logo: {
        src: OPENSALUD360_LOGO
      }
    }
  },
  {
    path: 'registro-profesional',
    alias: ['registro-abogado'],
    name: 'Registro Profesional',
    component: () => import('@/components/forms/ProfessionalSignupForm'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      // layout: PUBLIC_EXTENDED_LAYOUT,
      title: {
        text () {
          return getThemeName() === OPENLEGAL_THEME ? i18n.t('sign-up-lawyer') : i18n.t('sign-up-professional') 
        },
        hide: true
      }
    }
  },
  {
    path: 'registro-paciente',
    alias: ['registro-cliente', 'registro-empresas'],
    name: 'Registro Paciente',
    component: () => import('@/components/forms/PatientSignupForm'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text () {
          return getThemeName() === OPENLEGAL_THEME ? i18n.t('sign-up-customer') : i18n.t('sign-up-patient')
        },
        hide: true
      }
    }
  },
  {
    path: 'registro-centro',
    alias: ['registro-bufete'],
    name: 'Registro Centro',
    component: () => import('@/components/forms/CentersSignupForm'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text () {
          return i18n.t('sign-up-centre')
        },
        hide: true
      }
    }
  },
  {
   path: 'sign-in',
   name: 'Signin',
   component: () => import('@/components/views/SignIn'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text () {
          return i18n.t('log-in')
        }
      }
    }
  },
  {
    path: 'terminos-condiciones-paciente',
    name: 'TermsAndConditionsPatient',
    component: () => import('@/components/views/TermsAndConditionsPatient'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text () {
          return i18n.t('terms-and-conditions-patient')
        }
      }
    }
  },
  {
    path: 'terminos-condiciones-profesional',
    name: 'TermsAndConditionsProfessional',
    component: () => import('@/components/views/TermsAndConditionsProfessional'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text () {
          return i18n.t('terms-and-conditions-professional')
        }
      },
      
     
    }
  },
  {
    path: 'aviso-legal',
    name: 'LegalWarning',
    component: () => import('@/components/views/LegalWarning'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT, 
      title: {
        text () {
          return i18n.t('legal-warning')
        }
      },
      i18n: 'public/views/legal-warning.json'
    }
  },
  {
    path: 'aviso-legal-cookies',
    name: 'LegalWarningCookies',
    component: () => import('@/components/views/LegalWarningCookiesPolicyMx'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT, 
      title: {
        text () {
          return i18n.t('legal-warning')
        }
      }
    }
  },
  {
    path: 'politica-cookies',
    name: 'CookiesPolicy',
    component: () => import('@/components/views/CookiesPolicy'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT, 
      title: {
        text () {
          return i18n.t('cookies-policy')
        }
      },
      
      i18n: 'public/views/cookies-policy.json'
    }
  },
  {
    path: 'politica-privacidad',
    name: 'PrivacyPolicy',
    component: () => import('@/components/views/PrivacyPolicy'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT, 
      title: {
        text () {
          return i18n.t('privacy-policy.title')
        }
      },
      
      i18n: 'public/views/privacy-policy.json'
    }
  },
  {
    path: 'politica-privacidad-profesional',
    name: 'PrivacyPolicyProfessional',
    component: () => import('@/components/views/PrivacyPolicyProfessional'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT, 
      title: {
        text () {
          return i18n.t('privacy-policy-professional.title')
        }
      },
      
      i18n: 'public/views/privacy-policy-professional.json'
    }
  },
  {
    path: 'politica-sgsi',
    name: 'SGSIPolicy',
    component: () => import('@/components/views/SGSIPolicy'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT, 
      title: {
        text () {
          return i18n.t('sgsi-policy.title')
        }
      },
      
      i18n: 'public/views/sgsi-policy.json'
    }
  },
  {
    path: 'programa-pyme',
    name: 'Pyme',
    component: () => import('@/components/views/Pyme'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT, 
      title: {
        text () {
          return i18n.t('pyme.title')
        }
      },
      
      i18n: 'public/views/pyme.json'
    }
  },
  {
    path: 'faqs',
    name: 'FAQs',
    component: () => import('@/components/views/FAQs'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT, 
      title: {
        text () {
          return i18n.t('faqs-title')
        },
        hide: true
      },     
      i18n: 'public/views/faqs.json'
    }
  },
  {
    path: 'faqs/:groupId',
    name: 'FAQsGroup',
    component: () => import('@/components/views/FAQs'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT, 
      title: {
        text () {
          return i18n.t('faqs-title')
        },
        hide: true
      },
      
      i18n: 'public/views/faqs.json'
    }
  },
  {
    path: 'faqs/:groupId/:questionId',
    name: 'FAQsGroupQuestion',
    component: () => import('@/components/views/FAQs'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT, 
      title: {
        text () {
          return i18n.t('faqs-title')
        },
        hide: true
      },
      
      i18n: 'public/views/faqs.json'
    }
  },
  {
    path: 'contact/success',
    name: 'ContactFormSuccess',
    component: () => import('@/components/views/CompaniesContactFormSuccess'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('companies-contact-form.form.thank-you')
        }
      },
      i18n: 'forms/companies-contact-form.json',
    }
  },
  {
    path: 'Home/Login',
    name: 'Home',
    component: Home,
    beforeEnter: requireAuth
  },
  {
    path: '/login', beforeEnter(to, from, next){
      auth.auth.getSession();
    }
  },
  {
    path: 'search',
    name: 'public-search',
    component: () => import('@/components/webapp/patient/search/Search'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      i18n: 'public/views/patient/search',
			roles: [API_CLIENT_ROLE]
    }
  },
  {
    path: 'login/oauth2/code/cognito', beforeEnter(to, from, next){
      var currUrl = window.location.href;
      
      //console.log(currUrl);
      auth.auth.parseCognitoWebResponse(currUrl);
      //next();
    }
  },
	{
		// Route for current app version
		path: 'version',
		name: 'Version',
		component: Vue.component('version-view', { template: '<div>Version: {{ version }}</div>', data () { return { version: `${process.env.PACKAGE_VERSION}` } } }),
		meta: {
      footer: {
        disabled: true
      }
    }
	},
  {
		path: 'logout', component: LogoutSuccess,  beforeEnter(to, from, next){
		auth.logout();
		next();
	}
  },
  ...errorRoutes
]



// WEBPACK FOOTER //
// ./src/router/routes/public.routes.js